import { Component, Input, OnInit } from "@angular/core";
import { VidalyticsLoaderService } from "src/app/services/vidalytics.service";

@Component({
    selector: "video-player-vidalytics",
    templateUrl: "video-player-vidalytics.html",
    styleUrls: ["video-player-vidalytics.scss"],
    standalone: false
})
export class VideoPlayerVidalyticsComponent implements OnInit {
  @Input() vidalyticsEmbedId: string = "";
  @Input() vidalyticsEmbedIdMobile: string = "";
  isDesktop = window.innerWidth > 1024;
  videoClass = "vidalytics";

  constructor(public vidalyticsLoaderService: VidalyticsLoaderService) { }

  async ngOnInit() {
    this.setVidalytics();
  }

  /** Desktop id, or the mobile id when on mobile and one is configured. */
  get resolvedEmbedId(): string {
    if (this.isDesktop) return this.vidalyticsEmbedId || '';
    return this.vidalyticsEmbedIdMobile?.trim() ? this.vidalyticsEmbedIdMobile : (this.vidalyticsEmbedId || '');
  }

  setVidalytics() {
    this.vidalyticsLoaderService.loadVidalytics({
      vidalyticsEmbedId: this.resolvedEmbedId,
      buttonId: "button",
      showClass: "video__nextPageShown",
      hideClass: "video__nextPageHidden",
    });
  }
}
